import { render, staticRenderFns } from "./editAddress.vue?vue&type=template&id=77a2925c&"
import script from "./editAddress.vue?vue&type=script&lang=js&"
export * from "./editAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports